import Vue from 'vue'
import Vuex from 'vuex'
import {
  getAllTenantUsage,
  downloadAllTenantUsageCsv,
  getTopFeaturesMonthly,
  getTopTenants,
  downloadTopTenantsCsv,
  getRecentTenants,
  downloadRecentTenantsCsv,
  getRecentFeatures,
  downloadRecentFeaturesCsv,
  getRiskyTenants,
  downloadRiskyTenantsCsv,
  getRiskyFeatures,
  downloadRiskyFeaturesCsv,
  getOverallFeatureCount
} from '../apis/calls.js'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    allTenantUsage: [],
    allTenantUsagePagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 1,
    },
    topFeaturesMonthly: [],
    topTenants: [],
    recentTenants: [],
    recentFeatures: [],
    riskyTenants: [],
    riskyFeatures: [],
    overallFeatureCount: [],
  },
  mutations: {
    SET_ALL_TENANT_USAGE(state, data) {
      state.allTenantUsage = data
    },
    SET_ALL_TENANT_USAGE_PAGINATION(state, data) {
      state.allTenantUsagePagination = data
    },
    SET_TOP_FEATURES_MONTHLY(state, data) {
      state.topFeaturesMonthly = data
    },
    SET_TOP_TENANTS(state, data) {
      state.topTenants = data
    },
    SET_RECENT_TENANTS(state, data) {
      state.recentTenants = data
    },
    SET_RECENT_FEATURES(state, data) {
      state.recentFeatures = data
    },
    SET_RISKY_TENANTS(state, data) {
      state.riskyTenants = data
    },
    SET_RISKY_FEATURES(state, data) {
      state.riskyFeatures = data
    },
    SET_OVERALL_FEATURE_COUNT(state, data) {
      state.overallFeatureCount = data
    }
  },
  actions: {
    async fetchAllTenantUsage({ commit }, params = {}) {
      try {
        const { plan = null, page = 1, per_page = 10 } = typeof params === 'string' ? { plan: params } : (params || {})
        const response = await getAllTenantUsage({ plan, page, per_page })
        if (response.data.success === false) {
          commit('SET_ALL_TENANT_USAGE', [])
        } else {
          commit('SET_ALL_TENANT_USAGE', response.data.features || [])
          if (response.data.pagination) {
            commit('SET_ALL_TENANT_USAGE_PAGINATION', response.data.pagination)
          }
        }
      } catch (error) {
        alert('Error fetching all tenant usage: ' + error)
      }
    },
    async downloadAllTenantUsageCsv() {
      try {
        const response = await downloadAllTenantUsageCsv()
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'all-tenant-usage.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        alert('Error downloading all tenant usage CSV: ' + error)
      }
    },
    async fetchTopFeaturesMonthly({ commit }, plan = null) {
      try {
        const response = await getTopFeaturesMonthly(plan)
        if (response.data.success === false) {
          commit('SET_TOP_FEATURES_MONTHLY', [])
        } else {
          commit('SET_TOP_FEATURES_MONTHLY', response.data.features || [])
        }
      } catch (error) {
        alert('Error fetching top features monthly: ' + error)
      }
    },
    async fetchTopTenants({ commit }, plan = null) {
      try {
        const response = await getTopTenants(plan)
        if (response.data.success === false) {
          commit('SET_TOP_TENANTS', [])
        } else {
          commit('SET_TOP_TENANTS', response.data.data || [])
        }
      } catch (error) {
        alert('Error fetching top tenants: ' + error)
      }
    },
    async downloadTopTenantsCsv() {
      try {
        const response = await downloadTopTenantsCsv()
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'top-tenants.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        alert('Error downloading top tenants CSV: ' + error)
      }
    },
    async fetchRecentTenants({ commit }, plan = null) {
      try {
        const response = await getRecentTenants(plan)
        if (response.data.success === false) {
          commit('SET_RECENT_TENANTS', [])
        } else {
          commit('SET_RECENT_TENANTS', response.data.data || [])
        }
      } catch (error) {
        alert('Error fetching recent tenants: ' + error)
      }
    },
    async downloadRecentTenantsCsv() {
      try {
        const response = await downloadRecentTenantsCsv()
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'recent-tenants.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        alert('Error downloading recent tenants CSV: ' + error)
      }
    },
    async fetchRecentFeatures({ commit }, plan = null) {
      try {
        const response = await getRecentFeatures(plan)
        if (response.data.success === false) {
          commit('SET_RECENT_FEATURES', [])
        } else {
          commit('SET_RECENT_FEATURES', response.data.data || [])
        }
      } catch (error) {
        alert('Error fetching recent features: ' + error)
      }
    },
    async downloadRecentFeaturesCsv() {
      try {
        const response = await downloadRecentFeaturesCsv()
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'recent-features.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        alert('Error downloading recent features CSV: ' + error)
      }
    },
    async fetchRiskyTenants({ commit }, plan = null) {
      try {
        const response = await getRiskyTenants(plan)
        if (response.data.success === false) {
          commit('SET_RISKY_TENANTS', [])
        } else {
          commit('SET_RISKY_TENANTS', response.data.data || [])
        }
      } catch (error) {
        alert('Error fetching risky tenants: ' + error)
      }
    },
    async downloadRiskyTenantsCsv() {
      try {
        const response = await downloadRiskyTenantsCsv()
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'risky-tenants.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        alert('Error downloading risky tenants CSV: ' + error)
      }
    },
    async fetchRiskyFeatures({ commit }, plan = null) {
      try {
        const response = await getRiskyFeatures(plan)
        if (response.data.success === false) {
          commit('SET_RISKY_FEATURES', [])
        } else {
          commit('SET_RISKY_FEATURES', response.data.data || [])
        }
      } catch (error) {
        alert('Error fetching risky features: ' + error)
      }
    },
    async downloadRiskyFeaturesCsv() {
      try {
        const response = await downloadRiskyFeaturesCsv()
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'risky-features.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (error) {
        alert('Error downloading risky features CSV: ' + error)
      }
    },
    async fetchOverallFeatureCount({ commit }, plan = null) {
      try {
        const response = await getOverallFeatureCount(plan)
        commit('SET_OVERALL_FEATURE_COUNT', response.data)
      } catch (error) {
        alert('Error fetching overall feature count: ' + error)
      }
    },
  }
}